import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, filter, map, sortBy } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import TableRow from "@material-ui/core/TableRow";

import TableCellStyled from "../Common/TableCellStyled";
import ProfileSurveyDialog from "./ProfileSurvey/ProfileSurveyDialog";
import InstructionsDialog from "./ProfileSurvey/InstructionsDialog";

import { formatDate } from "../../utils/date";
import { displayData } from "../../utils/data";
import { getAttributeValue } from "../../utils/profile";
import {
  getVerificationStatus,
  getLukeActionColor,
} from "../../utils/eventGroups";

import colors from "../../assets/style/colors";

const styles = {
  tableRowHover: {
    "&:hover": {
      backgroundColor: `${colors.lightGreenBg} !important`,
    },
  },
};

const ProfileVerificationHumanRow = (props) => {
  const {
    classes,
    item,
    index,
    view,
    views,
    preSurveys,
    lov,
    language,
    profile,
  } = props;

  const dataCell = (data, text54 = false) => {
    return (
      <TableCellStyled
        className={clsx({
          "text-54": text54,
        })}
        style={{
          padding: "0px 18px !important",
        }}
      >
        {data}
      </TableCellStyled>
    );
  };

  const surveyRow = (survey, lukeAction, index) => {
    const attr151 = JSON.parse(getAttributeValue(survey, 151));

    return (
      <TableRow
        style={{
          backgroundColor: index % 2 === 1 ? colors.tableDarkBg : colors.white,
        }}
        hover={true}
        classes={{ hover: classes.tableRowHover }}
      >
        {dataCell(
          <Grid container alignItems="center">
            <Grid
              item
              style={{
                paddingLeft:
                  view !== views.history && get(survey, ["type", "id"]) === 91
                    ? "50px"
                    : "0px",
              }}
            >
              <ProfileSurveyDialog
                title={get(survey, ["type", `name_${language}`])}
                surveys={
                  get(survey, ["type", "id"]) === 91
                    ? { preSurvey: survey }
                    : { lastSurvey: survey }
                }
                profileId={get(profile, ["id"])}
                language={language}
                profileName={get(survey, ["profile", "name"])}
                onlyOneSurvey
                hide={{
                  new: true,
                  leftCol: true,
                }}
              />
            </Grid>
          </Grid>
        )}
        {dataCell(formatDate(get(survey, ["created_on"])), true)}
        {dataCell(
          get(survey, ["zone"])
            ? `${get(survey, ["zone", "name"])} - ${get(survey, [
                "zone",
                "site",
                "name",
              ])}`
            : I18n.get("profiles_remote"),
          true
        )}
        {dataCell(
          get(survey, ["device", "name"])
            ? get(survey, ["device", "name"])
            : I18n.get("profiles_online"),
          true
        )}
        {dataCell(
          <Grid container alignItems="center">
            <Grid
              item
              className="text-54"
              style={{ minWidth: "17px", textAlign: "right" }}
            >
              {get(attr151, ["survey_state", "no"])}
            </Grid>
            <Grid
              item
              className="text-87 bold-500"
              style={{ marginLeft: "5px", marginRight: "15px" }}
            >
              {I18n.get("profiles_no")}
            </Grid>
            <Grid
              item
              className="text-54"
              style={{ minWidth: "17px", textAlign: "right" }}
            >
              {get(attr151, ["survey_state", "yes"])}
            </Grid>
            <Grid
              item
              className="text-87 bold-500"
              style={{ marginLeft: "5px", marginRight: "15px" }}
            >
              {I18n.get("profiles_yes")}
            </Grid>
            <Grid
              item
              className="text-54"
              style={{ minWidth: "17px", textAlign: "right" }}
            >
              {get(attr151, ["survey_state", "other"])}
            </Grid>
            <Grid
              item
              className="text-87 bold-500"
              style={{ marginLeft: "5px" }}
            >
              {I18n.get("profiles_other")}
            </Grid>
          </Grid>
        )}
        {lukeAction
          ? dataCell(
              <Grid container alignItems="center">
                <Grid
                  style={{
                    marginRight: "5px",
                    width: "14px",
                    height: "14px",
                    backgroundColor: getLukeActionColor(
                      getAttributeValue(lukeAction, 159)
                    ),
                    borderRadius: "2px",
                  }}
                />
                <Grid item>
                  <InstructionsDialog
                    profileName={get(survey, ["profile", "name"])}
                    lukeAction={lukeAction}
                    lov={lov}
                    language={language}
                    surveyStatus={getVerificationStatus(survey)}
                  />
                </Grid>
              </Grid>
            )
          : dataCell(
              <Grid container alignItems="center">
                <Grid item>-</Grid>
              </Grid>
            )}
        {dataCell(displayData(get(item, ["description"])), true)}
        {dataCell("-", true)}
        {dataCell(get(survey, ["created_by"]), true)}
      </TableRow>
    );
  };

  let survey = get(
    filter(get(item, ["events"]), (e) => [81].includes(get(e, ["type", "id"]))),
    [0]
  );

  if (!survey) {
    return null;
  }

  let events91 = filter(
    preSurveys,
    (e) => get(e, ["reference_event_id"]) === get(survey, ["id"])
  );

  let lukeAction =
    get(
      filter(get(survey, ["events"]), (e) => get(e, ["type", "id"]) === 88),
      [0]
    ) ||
    get(
      filter(get(item, ["events"]), (e) => get(e, ["type", "id"]) === 88),
      [0]
    );

  if (view === views.history) {
    return (
      <>
        {map(
          sortBy(events91, (e) => -get(e, ["created_on"])),
          (e, i) => (
            <React.Fragment key={get(e, ["id"])}>
              {surveyRow(e, null, index + i + 1)}
            </React.Fragment>
          )
        )}
        {surveyRow(survey, lukeAction, index)}
      </>
    );
  }

  return (
    <>
      {surveyRow(survey, lukeAction, index)}
      {map(events91, (e, i) => (
        <React.Fragment key={get(e, ["id"])}>
          {surveyRow(e, null, index + i + 1)}
        </React.Fragment>
      ))}
    </>
  );
};

export default withStyles(styles)(ProfileVerificationHumanRow);
